import { useEffect } from "react";
import { Link } from "react-router-dom";

import { pageTitle } from "../config/site";

export function NotFoundPage() {
  useEffect(() => {
    document.title = pageTitle("Not found");
  }, []);
  return (
    <div className="landing">
      <h1 className="landing-title">This thread leads nowhere</h1>
      <p className="landing-lead">We could not find that page.</p>
      <Link className="landing-card" to="/">Back to the start</Link>
    </div>
  );
}
